// ════════════════════════════════════════════════════════════════════════
// MonologuePracticePage.tsx — Visor de discursos de un solo hablante
// ════════════════════════════════════════════════════════════════════════
// Mismo tratamiento visual EN/ES que los diálogos, pero sin turnos de
// hablante — cada segmento tiene una etiqueta de tiempo/sección.
// ════════════════════════════════════════════════════════════════════════

import { useParams, Link } from 'react-router-dom';
import { DashboardLayout } from '../layouts/DashboardLayout/DashboardLayout';
import { AppSidebarMenu } from '../components/AppSidebarMenu/AppSidebarMenu';
import { findMonologue } from '../data/monologues';
import styles from './InterviewPracticePage.module.css';

function Paragraphs({ text, className }: { text: string; className: string }) {
  return (
    <>
      {text.split('\n\n').map((para, i) => (
        <p key={i} className={className} style={i > 0 ? { marginTop: '0.5rem' } : undefined}>
          {para}
        </p>
      ))}
    </>
  );
}

export default function MonologuePracticePage() {
  const { slug } = useParams<{ slug: string }>();
  const monologue = findMonologue(slug);

  if (!monologue) {
    return (
      <DashboardLayout.Root>
        <DashboardLayout.Sidebar>
          <AppSidebarMenu />
        </DashboardLayout.Sidebar>
        <DashboardLayout.Content>
          <h1 className={styles.pageTitle}>Discurso no encontrado</h1>
          <Link to="/dashboard/leads">Volver al panel</Link>
        </DashboardLayout.Content>
      </DashboardLayout.Root>
    );
  }

  return (
    <DashboardLayout.Root>
      <DashboardLayout.Sidebar>
        <AppSidebarMenu />
      </DashboardLayout.Sidebar>

      <DashboardLayout.Content>
        <div className={styles.pageHeader}>
          <h1 className={styles.pageTitle}>{monologue.title}</h1>
          <p className={styles.pageSubtitle}>{monologue.subtitle}</p>
        </div>

        <div className={styles.script}>
          {monologue.segments.map((seg, i) => (
            <div key={i} className={styles.turn}>
              <p className={styles.speaker} style={{ color: 'var(--brand-accent-dark)' }}>
                {seg.time ? `${seg.time} · ${seg.label}` : seg.label}
              </p>
              <Paragraphs text={seg.en} className={styles.en} />
              <Paragraphs text={seg.es} className={styles.es} />
            </div>
          ))}
        </div>
      </DashboardLayout.Content>
    </DashboardLayout.Root>
  );
}
